import { render, staticRenderFns } from "./StartCall.vue?vue&type=template&id=5e258b52&scoped=true&"
import script from "./StartCall.vue?vue&type=script&lang=ts&"
export * from "./StartCall.vue?vue&type=script&lang=ts&"
import style0 from "./StartCall.vue?vue&type=style&index=0&id=5e258b52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e258b52",
  null
  
)

export default component.exports